class CollectionSliderTabs extends HTMLElement {
  constructor(){
    super();
		this.tabs = this.querySelectorAll('.tabs .collection-slider-tab');
    this.sliders = this.querySelectorAll('.collection-block-wrapper');
  }

  connectedCallback() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.updateActiveTab.bind(this));
    });
  }

  disconnectedCallback() {
    this.tabs.forEach(tab => {
      tab.removeEventListener('click', this.updateActiveTab);
    });
  }

  updateActiveTab(e) {
    const currentTab = e.currentTarget;
    const isActive = currentTab.classList.contains('active');

    this.tabs.forEach(tab => {
      tab.classList.remove('active');
    });

    if (!isActive) {
      currentTab.classList.add('active');
      this.updateActiveSlider(currentTab.dataset.collectionTab);
      this.updateChronoPhase(currentTab.dataset.chronoPhaseClass);
    } else {
      this.updateActiveSlider('all');
    }
  }

  updateActiveSlider(tab) {
    this.sliders.forEach(slider => {
      slider.classList.remove('active');
      if (slider.dataset.collectionTab === tab) {
        slider.classList.add('active');
      }
    });
  }

  updateChronoPhase(chronoPhaseClass) {
    const sectionWrapper = this.closest('.collection-slider-section-wrapper');
    const backgroundDivs = sectionWrapper.querySelectorAll('.chrone-phase-background');
    backgroundDivs.forEach(div => {
      div.classList.remove('active');
    });
    const activeBackgroundDiv = sectionWrapper.querySelector(`.chrone-phase-background.${chronoPhaseClass}`);
    activeBackgroundDiv?.classList.add('active');
}
}

if (!window.customElements.get("collection-slider-tabs")) {
  window.customElements.define("collection-slider-tabs", CollectionSliderTabs );
}

class MulticolumnPages extends HTMLElement {
  constructor(){
    super();
    this.nextBtn = this.querySelector('.custom-multicolumn-next-btn');
    this.prevBtn = this.querySelector('.custom-multicolumn-prev-btn');
    this.pagesCount = this.dataset.pagesCount * 1;
    this.currentPage = 1;
    this.initialHeightUpdate();
  }

  connectedCallback() {
    this.nextBtn.addEventListener('click', this.goToNextPage.bind(this));
    this.prevBtn.addEventListener('click', this.goToPrevPage.bind(this));
    window.addEventListener('resize', this.updatePagesHeight.bind(this));
  }

  disconnectedCallback() {
    this.nextBtn.removeEventListener('click', this.goToNextPage());
    this.prevBtn.removeEventListener('click', this.goToPrevPage());
    window.removeEventListener('resize', this.updatePagesHeight);
  }

  initialHeightUpdate() {
    const section = this;
    document.addEventListener('DOMContentLoaded', () => {
      section.updatePagesHeight();
    });
  }

  updatePagesHeight() {
    const blocks = this.querySelectorAll('.custom-multicolumn-blocks-wrapper');
    let maxHeight = 0;

    blocks.forEach(block => {
      const blockHeight = block.offsetHeight;
      if (blockHeight > maxHeight) {
        maxHeight = blockHeight;
      }
    });

    this.querySelector('.custom-multicolumn-pages-wrapper').style.height = `${maxHeight}px`;
  }

  goToNextPage() {
    if(this.currentPage < this.pagesCount){
      this.currentPageSelector = `.custom-multicolumn-blocks-wrapper[data-page="page-${this.currentPage}"]`;
      this.currentPage++;
      this.nextPageSelector = `.custom-multicolumn-blocks-wrapper[data-page="page-${this.currentPage}"]`;
      this.querySelector(this.currentPageSelector).classList.add('prev-page');
      this.querySelector(this.currentPageSelector).classList.remove('active-page');
      this.querySelector(this.nextPageSelector).classList.add('active-page');
      this.querySelector(this.nextPageSelector).classList.remove('next-page');
    }
    if (this.currentPage === this.pagesCount) {
      this.disableButton(this.nextBtn);
    }
    this.enableButton(this.prevBtn);
  }

  goToPrevPage() {
    if(this.currentPage > 1){
      this.currentPageSelector = `.custom-multicolumn-blocks-wrapper[data-page="page-${this.currentPage}"]`;
      this.currentPage--;
      this.prevPageSelector = `.custom-multicolumn-blocks-wrapper[data-page="page-${this.currentPage}"]`;

      this.querySelector(this.currentPageSelector).classList.add('next-page');
      this.querySelector(this.currentPageSelector).classList.remove('active-page');
      this.querySelector(this.prevPageSelector).classList.remove('prev-page');
      this.querySelector(this.prevPageSelector).classList.add('active-page');
    }
    if (this.currentPage === 1) {
      this.disableButton(this.prevBtn);
    }
    this.enableButton(this.nextBtn);
  }

  disableButton(btn) {
    btn.disabled = true;
    btn.classList.add('multicolumn-btn-disabled');
  }

  enableButton(btn) {
    btn.disabled = false;
    btn.classList.remove('multicolumn-btn-disabled');
  }
}

if (!window.customElements.get("multicolumn-pages")) {
  window.customElements.define("multicolumn-pages", MulticolumnPages);
}

class IngredientAccordion extends HTMLElement {
  constructor(){
    super();
    this.accordionTrigger = this.querySelector('.trigger .accordion-trigger');
    this.accordionWrapper = this.querySelector('.accordion-wrapper');
    this.initialHeight = this.querySelector('.accordion-title').offsetHeight + 20;
    // if (window.innerWidth < 990) {
    //   this.initialHeight = this.initialHeight - 20;
    // }
    this.inProgress = false;
  }

  connectedCallback() {
    this.style.height = `${this.initialHeight}px`;
    let accordion = this;
    setTimeout(() => {
      accordion.style.transition = 'height 0.3s ease, opacity 0.3s ease';
      accordion.style.opacity = 1;
    },200);
    this.setFullHeight();
    this.accordionTrigger.addEventListener('click', this.updateHeight.bind(this));
    window.addEventListener('resize', this.setFullHeight.bind(this));
  }

  disconnectedCallback() {
    this.accordionTrigger.removeEventListener('click', this.updateHeight);
    window.removeEventListener('resize', this.setFullHeight);
  }

  setFullHeight() {
    const titleHeight = this.querySelector('.accordion-title').offsetHeight;
    const contentHeight = this.querySelector('.ingredient-content').offsetHeight;
    let productBlockHeight = 0;
    if(this.querySelector('.ingredient-product-block-wrapper')){
      productBlockHeight = this.querySelector('.ingredient-product-block-wrapper').offsetHeight + 30;
    }
    
    if(window.innerWidth < 990) {
      this.fullHeight = titleHeight + contentHeight + productBlockHeight + 60;
    }
    else {
      this.fullHeight = titleHeight;
    if(contentHeight > this.fullHeight) {
      this.fullHeight = contentHeight;
    }
    if (productBlockHeight > this.fullHeight) {
      this.fullHeight = productBlockHeight;
    }
    this.fullHeight += 40;
    }
  }

  openAccordion() {
    let content = this.querySelector('.ingredient-content');
    let productBlocks = this.querySelectorAll('.ingredient-product-wrapper');
    this.style.height = `${this.fullHeight}px`;
    this.accordionWrapper.classList.add('open');
    content.style.opacity = 1;
    productBlocks.forEach(productBlock => {
      productBlock.style.opacity = 1;
    });
  }

  closeAccordion() {
    let content = this.querySelector('.ingredient-content');
    let productBlocks = this.querySelectorAll('.ingredient-product-wrapper');
    this.style.height = `${this.initialHeight}px`;
    setTimeout(() => {
      content.style.opacity = 0;
      productBlocks.forEach(productBlock => {
        productBlock.style.opacity = 0;
      });
    }, 200);
    this.accordionWrapper.classList.remove('open');
  }

  updateHeight(e) {
    if(!this.inProgress) {
      this.inProgress = true;
      if(this.accordionWrapper.classList.contains('open')) {
        this.closeAccordion();
      }
      else {
        this.closeOtherAccordions();
        this.openAccordion();
      }
      let tempAccordion = this;
      setTimeout(() => {
        tempAccordion.inProgress = false;
      },400);
    }
  }

  closeOtherAccordions() {
    document.querySelectorAll('ingredient-accordion').forEach(accordion => {
      if(accordion !== this) {
        accordion.closeAccordion();
      }
    });
  }
}

if (!window.customElements.get("ingredient-accordion")) {
  window.customElements.define("ingredient-accordion", IngredientAccordion);
}

class IngredientFilters extends HTMLElement {
  constructor(){
    super();
    this.filterAll = this.querySelector('.ingredient-filter-all');
    this.filterAllMobile = this.querySelector('.ingredient-filter-all-mobile');
    this.filters = this.querySelectorAll('.ingredients-filter-btn:not(.ingredient-filter-all)');
    this.mobileFilters = this.querySelectorAll('.ingredients-filter-btn-mobile:not(.ingredient-filter-all-mobile)');
    this.ingredients = this.querySelectorAll('ingredient-accordion');
    this.hasActiveFilter = false;
    this.mobileDrawerOpener = this.querySelector('.ingredients-filters-drawer-opener');
    this.filtersDrawer = this.querySelector('.ingredients-filters-drawer');
    this.drawerOverlay = this.querySelector('.ingredients-filter-drawer-overlay');
    this.drawerCloseBtn = this.querySelector('.ingredients-drawer-close-btn');
    this.clearAllFiltersBtn = this.querySelector('.clear-all-filters-button');
    this.activeFiltersCount = 0;
    this.filtersCount = this.querySelector('.active-filters-count');
  }

  connectedCallback() {
    this.filterAll.addEventListener('click', this.clearAllFilters.bind(this));

    this.filters.forEach(filter => {
      filter.addEventListener('click', this.updateFilter.bind(this));
    });

    this.filterAllMobile.addEventListener('click', this.clearAllFilters.bind(this));

    this.mobileFilters.forEach(filter => {
      filter.addEventListener('click', this.updateFilter.bind(this));
    });

    this.mobileDrawerOpener.addEventListener('click', this.openFiltersDrawer.bind(this));
    this.drawerCloseBtn.addEventListener('click', this.openFiltersDrawer.bind(this));
    this.clearAllFiltersBtn.addEventListener('click', this.clearAllFilters.bind(this));
  }

  disconnectedCallback() {
    this.filterAll.removeEventListener('click', this.clearAllFilters);

    this.filters.forEach(filter => {
      filter.removeEventListener('click', this.updateFilter);
    });

    this.filterAllMobile.removeEventListener('click', this.clearAllFilters);

    this.mobileFilters.forEach(filter => {
      filter.removeEventListener('click', this.updateFilter);
    });

    this.mobileDrawerOpener.removeEventListener('click', this.openFiltersDrawer);
    this.drawerCloseBtn.removeEventListener('click', this.openFiltersDrawer);
    this.clearAllFiltersBtn.removeEventListener('click', this.clearAllFilters);
  }

  openFiltersDrawer() {
    document.documentElement.classList.toggle('no-scroll');
    let drawer = this;
    if(this.filtersDrawer.classList.contains('opened')) {
      this.filtersDrawer.classList.remove('opened');
       setTimeout(() => {
         drawer.drawerOverlay.classList.remove('opened');
       },300);
    }
    else {
      this.drawerOverlay.classList.add('opened');
      setTimeout(() => {
         drawer.filtersDrawer.classList.add('opened');
       },100);
    }
  }

  clearAllFilters(e) {
    this.showAllIngredients();
    if(e.currentTarget.classList.contains('mobile-btn')) {
      if (!this.openCloseInitiated) {
        this.openCloseInitiated = true;
        let tempIngredientFilters = this;
        setTimeout(() => {
          tempIngredientFilters.openFiltersDrawer();
          this.openCloseInitiated = false;
        }, 200);
        setTimeout(() => {
          tempIngredientFilters.openCloseInitiated = false;
        }, 400);
      }
    }
  }

  updateFilter(e) {
    let isMobileFilter = false;
    if(e.currentTarget.classList.contains('mobile-btn')) {
      isMobileFilter = true;
      let tempIngredientFilters = this;
      if (!this.openCloseInitiated) {
        this.openCloseInitiated = true;
        setTimeout(() => {
          tempIngredientFilters.openFiltersDrawer();
        }, 200);
        setTimeout(() => {
          tempIngredientFilters.openCloseInitiated = false;
        }, 400);
      }
    }
    if(e.currentTarget.classList.contains('active')) {
      this.deactivateFilter(e.currentTarget, isMobileFilter);
    }
    else {
      this.activateFilter(e.currentTarget, isMobileFilter);
    }
  }

  showAllIngredients() {
    this.updateFilterCount();
    this.filterAll.classList.add('active');
    this.filterAllMobile.classList.add('active');
    this.ingredients.forEach(ingredient => {
      if(!ingredient.classList.contains('ingredient-visible')) {
        ingredient.classList.add('ingredient-visible');
      }
    });
    this.clearFilters();
  }

  clearFilters() {
    this.filters.forEach(filter => {
      filter.classList.remove('active');
    });
    this.mobileFilters.forEach(filter => {
      filter.classList.remove('active');
    });
    this.hasActiveFilter = false;
  }

  activateFilter(filter, isMobileFilter) {
    this.updateFilterCount(true);
    this.deactivateFilterAll();
    this.hasActiveFilter = true;
    filter.classList.add('active');
    let filterCategory = filter.dataset.filter;
    if(isMobileFilter) {
      this.filters.forEach(desktopFilter => {
        if(desktopFilter.dataset.filter === filterCategory) {
          desktopFilter.classList.add('active');
        }
      });
    }
    else {
      this.mobileFilters.forEach(mobileFilter => {
        if(mobileFilter.dataset.filter === filterCategory) {
          mobileFilter.classList.add('active');
        }
      });
    }
    this.ingredients.forEach(ingredient => {
      if(ingredient.dataset.category === filterCategory) {
        if(!ingredient.classList.contains('ingredient-visible')) {
          ingredient.classList.add('ingredient-visible');
        }
      }
    });
  }

  deactivateFilterAll() {
    if(this.hasActiveFilter == false) {
      this.ingredients.forEach(ingredient => {
        if(ingredient.classList.contains('ingredient-visible')) {
          ingredient.classList.remove('ingredient-visible');
        }
      });
      this.filterAll.classList.remove('active');
      this.filterAllMobile.classList.remove('active');
    }
  }

  updateFilterCount(incrementFilter) {
    if(incrementFilter === true) {
      this.activeFiltersCount += 1;
    }
    else if(incrementFilter === false) {
      this.activeFiltersCount -= 1;
    }
    else {
      this.activeFiltersCount = 0;
    }

    if(this.activeFiltersCount > 0) {
      this.clearAllFiltersBtn.closest('.ingredients-filter-darawer-header').classList.add('clear-all-visible');
    }
    else {
      this.clearAllFiltersBtn.closest('.ingredients-filter-darawer-header').classList.remove('clear-all-visible');
    }

    this.filtersCount.innerHTML = this.activeFiltersCount;
  }

  deactivateFilter(filter, isMobileFilter) {
    this.updateFilterCount(false);
    filter.classList.remove('active');
    if(isMobileFilter) {
      this.filters.forEach(desktopFilter => {
        if(desktopFilter.dataset.filter === filter.dataset.filter) {
          desktopFilter.classList.remove('active');
        }
      });
    }
    else {
      this.mobileFilters.forEach(mobileFilter => {
        if(mobileFilter.dataset.filter === filter.dataset.filter) {
          mobileFilter.classList.remove('active');
        }
      });
    }
    let filterCategory = filter.dataset.filter;
    this.ingredients.forEach(ingredient => {
      if(ingredient.dataset.category === filterCategory) {
        if(ingredient.classList.contains('ingredient-visible')) {
          ingredient.classList.remove('ingredient-visible');
        }
      }
    });
    this.checkForActiveFilter();
  }

  checkForActiveFilter() {
    let hasActiveFilter = false;
    this.filters.forEach(filter => {
      if(filter.classList.contains('active')) {
        hasActiveFilter = true;
      }
    });
    if(!hasActiveFilter) {
      this.hasActiveFilter = false;
      this.showAllIngredients();
    }
  }
}
if (!window.customElements.get("ingredient-filters")) {
  window.customElements.define("ingredient-filters", IngredientFilters);
}

class CustomAccordion extends HTMLElement {
  constructor(){
    super();
    this.accordionTrigger = this.querySelector('.details .summary');
    this.accordionWrapper = this.querySelector('.accordion-wrapper');
    this.initialHeight = this.querySelector('.summary').offsetHeight;
    this.inProgress = false;
  }

  connectedCallback() {
    this.style.height = `${this.initialHeight}px`;
    let accordion = this;
    setTimeout(() => {
      accordion.style.transition = 'height 0.3s ease, opacity 0.3s ease';
      accordion.style.opacity = 1;
    },200);
    this.setFullHeight();
    this.accordionTrigger.addEventListener('click', this.updateHeight.bind(this));
    window.addEventListener('resize', this.setFullHeight.bind(this));

    if (this.classList.contains('initially-opened')) {
      this.openAccordion();
    }
  }

  disconnectedCallback() {
    this.accordionTrigger.removeEventListener('click', this.updateHeight.bind(this));
    window.removeEventListener('resize', this.setFullHeight.bind(this));
  }

  setFullHeight() {
    const titleHeight = this.querySelector('.summary').offsetHeight;
    const contentHeight = this.querySelector('.accordion__content > *:first-child').offsetHeight;
    if (this.dataset.layout === 'row') {
      this.fullHeight = titleHeight + contentHeight + 20;
    }
    else {
      if(window.innerWidth < 990) {
        this.fullHeight = titleHeight + contentHeight + 20;
      }
      else {
        this.fullHeight = titleHeight;
        if(contentHeight > this.fullHeight) {
          this.fullHeight = contentHeight;
        }
        this.fullHeight += 40;
      }
    }
  }

  updateHeight(e) {
    if(!this.inProgress) {
      this.inProgress = true;
      if(this.accordionWrapper.classList.contains('open')) {
        this.closeAccordion();
      }
      else {
        this.parent = this.parentElement;
        this.closeOtherAccordions(this.parent);
        this.openAccordion();
      }
      let tempAccordion = this;
      setTimeout(() => {
        tempAccordion.inProgress = false;
      },400);
    }
  }

  openAccordion() {
    if (this.closest('footer') != undefined) {
      this.oldOpenAccordion();
    } else {
      if (this.closest('.product-additional-info') == undefined) {
        this.mql = window.matchMedia('(min-width: 990px)');
      } else {
        this.mql = window.matchMedia('(min-width: 0px)');
      }
      let content = this.querySelector('.accordion__content');
      this.detailsOpener = this.querySelector('.details-opener');
      let customHeight = 15;
      if (this.dataset.customHeight != undefined && window.innerWidth > 990) {
        customHeight = Number(this.dataset.customHeight);
      }
      if (window.innerWidth < 990) {
        this.style.height = `${this.fullHeight}px`;
      }
      else {
        this.style.height = `${this.fullHeight + customHeight}px`;
      }
      // this.style.height =  this.mql.matches ? `${this.fullHeight + customHeight}px` : `${this.detailsOpener.offsetHeight}px`;
      this.accordionWrapper.classList.add('open');
      this.classList.add('opened');
      content.style.opacity = 1;
    }
  }

  oldOpenAccordion() {
    let content = this.querySelector('.accordion__content');
    let customHeight = 15;
    if (this.dataset.customHeight != undefined) {
      customHeight = Number(this.dataset.customHeight);
    }
    this.style.height = `${this.fullHeight + customHeight}px`;
    this.accordionWrapper.classList.add('open');
    content.style.opacity = 1;
  }

  closeAccordion() {
    let content = this.querySelector('.accordion__content');
    this.style.height = `${this.initialHeight}px`;
    setTimeout(() => {
      content.style.opacity = 0;
    }, 200);
    this.accordionWrapper.classList.remove('open');
    this.classList.remove('opened');
  }

  closeOtherAccordions(parent) {
    parent.querySelectorAll('custom-accordion').forEach(accordion => {
      if(accordion !== this) {
        accordion.closeAccordion();
      }
    });
  }
}

if (!window.customElements.get("custom-accordion")) {
  window.customElements.define("custom-accordion", CustomAccordion);
}

class ProductDescription extends HTMLElement {
  constructor() {
    super();
    this.readMoreText = this.dataset.readMoreText;
    this.readLessText = this.dataset.readLessText;
    this.desctiptionWrapper = this.querySelector('.product__description-wrapper');
    this.textTruncated = this.querySelector('.product__description.truncated');
    this.textFull = this.querySelector('.product__description.full-text');
    this.button = document.createElement('button');
    this.button.classList.add('read-more-button');
    this.button.innerHTML = this.readMoreText;
    this.buttonHeight = this.button.offsetHeight;
    this.fullDescriptionHeight = 0;
  }

  connectedCallback() {
    this.truncatedTextHeight = this.textTruncated.offsetHeight;
    this.desctiptionWrapper.style.height = this.truncatedTextHeight + 'px';
    this.appendChild(this.button);

    this.button.addEventListener('click', this.toggleDescription.bind(this));
  }

  toggleDescription() {
    if (!this.desctiptionWrapper.classList.contains('expanded')) {
      this.showFullText();
    } else {
      this.showTruncatedText();
    }
  }

  showFullText() {
    this.textFull.classList.remove('hidden');
    this.textTruncated.classList.add('hidden');
    if (this.fullDescriptionHeight === 0) {
      this.fullDescriptionHeight = this.textFull.offsetHeight + this.buttonHeight;
    }
    this.desctiptionWrapper.style.height = this.fullDescriptionHeight + 'px';

    this.desctiptionWrapper.classList.add('expanded');
    this.button.innerText = this.readLessText;
  }

  showTruncatedText() {
    this.desctiptionWrapper.style.height = this.truncatedTextHeight + 'px';
    let productDescription = this;

    setTimeout(function() {
      productDescription.textFull.classList.add('hidden');
      productDescription.textTruncated.classList.remove('hidden');
      productDescription.desctiptionWrapper.classList.remove('expanded');
      productDescription.button.innerText = productDescription.readMoreText;
    }, 300);
  }
}

if (!window.customElements.get("product-description")) {
  window.customElements.define("product-description", ProductDescription);
}

class DrawerOpener extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.querySelector(`#${this.dataset.drawerId}`);
    this.drawerOverlay = this.drawer.querySelector('.drawer-overlay');
    this.closeBtn = this.drawer.querySelector('.drawer-close-btn');
  }

  connectedCallback() {
    this.addEventListener('click', this.openDrawer.bind(this));
    this.drawerOverlay.addEventListener('click', this.closeDrawer.bind(this));
    this.closeBtn.addEventListener('click', this.closeDrawer.bind(this));
  }

  openDrawer() {
    document.body.classList.add('overflow-hidden-desktop');
    this.drawer.classList.add('active');
  }

  closeDrawer() {
    document.body.classList.remove('overflow-hidden-desktop');
    this.drawer.classList.remove('active');
  }
}

if (!window.customElements.get("drawer-opener")) {
  window.customElements.define("drawer-opener", DrawerOpener);
}


class FaqAccordion extends HTMLElement {
  constructor(){
    super();
    this.accordionTrigger = this.querySelector('.faq-accordion-trigger');
    this.accordionWrapper = this.querySelector('.faq-accordion-wrapper');
    this.initialHeight = this.querySelector('.faq-accordion-title').offsetHeight + 40;
    this.subAccordions = this.querySelectorAll('faq-sub-accordion');
    this.inProgress = false;
  }

  connectedCallback() {
    this.accordionWrapper.style.height = `${this.initialHeight}px`;
    let accordion = this;
    setTimeout(() => {
      accordion.accordionWrapper.style.transition = 'height 0.3s ease, opacity 0.3s ease';
      accordion.accordionWrapper.style.opacity = 1;
      accordion.setFullHeight();
      if (this.classList.contains('initially-opened')) {
        this.openAccordion();
      }
    },200);

    this.accordionTrigger.addEventListener('click', this.updateHeight.bind(this));
    window.addEventListener('resize', this.heightsUpdate.bind(this));
  }

  heightsUpdate() {
    let accordion = this;
    setTimeout(() => {
      accordion.setFullHeight();
      accordion.initialHeight = accordion.querySelector('.faq-accordion-title').offsetHeight + 40;
      if(accordion.accordionWrapper.classList.contains('open')) {
        accordion.accordionWrapper.style.height = `${this.fullHeight}px`;
      }
      else {
        accordion.accordionWrapper.style.height = `${this.initialHeight}px`;
      }

    },200);
  }
  setFullHeight() {
   const headerHeight = this.querySelector('.faq-accordion-title').offsetHeight;
   const contentHeight = this.querySelector('.faq-accordion-content').offsetHeight;
   if(window.innerWidth < 990) {
    this.fullHeight = contentHeight + headerHeight + 40;
   }
   else {
    if(contentHeight > headerHeight) {
      this.fullHeight = contentHeight + 40;
    }
    else {
      this.fullHeight = headerHeight + 40;
    }
   }

  }

  updateHeight(e, subAccordionHeight) {
    if(e) {
      if(!this.inProgress) {
        this.inProgress = true;
        if(this.accordionWrapper.classList.contains('open')) {
          this.closeAccordion();
        }
        else {
          this.parent = this.parentElement;
          this.closeOtherAccordions(this.parent);
          this.openAccordion();
        }
        let tempAccordion = this;
        setTimeout(() => {
          tempAccordion.inProgress = false;
        },400);
      }
    }
    else {
      if(subAccordionHeight) {
        let newHeight = this.fullHeight + subAccordionHeight;
        this.accordionWrapper.style.height = `${newHeight}px`;
      }
      else {
        this.accordionWrapper.style.height = `${this.fullHeight}px`;
      }
    }

  }

  openAccordion() {
    let content = this.querySelector('.faq-accordion-content');
    content.classList.remove('closed');
    this.accordionWrapper.style.height = `${this.fullHeight + 15}px`;
    this.accordionWrapper.classList.add('open');
    content.style.opacity = 1;
  }

  closeAccordion() {
    let content = this.querySelector('.faq-accordion-content');
    this.accordionWrapper.style.height = `${this.initialHeight}px`;
    this.subAccordions.forEach(subAccordion => {
      subAccordion.closeAccordion();
    });
    setTimeout(() => {
      content.style.opacity = 0;
    }, 200);
    setTimeout(() => {
      content.classList.add('closed');
    },300);
    this.accordionWrapper.classList.remove('open');
  }

  closeOtherAccordions(parent) {
    parent.querySelectorAll('faq-accordion').forEach(accordion => {
      if(accordion !== this) {
        accordion.closeAccordion();
      }
    });
  }
}

if (!window.customElements.get("faq-accordion")) {
  window.customElements.define("faq-accordion", FaqAccordion);
}


class FaqSubAccordion extends HTMLElement {
  constructor(){
    super();
    this.accordionTrigger = this.querySelector('.sub-accordion-wrapper');
    this.initialHeight = this.querySelector('.sub-accordion-title').offsetHeight + 20;
    this.inProgress = false;
    this.parentAccordion = this.closest('faq-accordion');
    this.siblingAccordions = this.parentElement.querySelectorAll('faq-sub-accordion');
  }

  connectedCallback() {
    this.accordionTrigger.style.height = `${this.initialHeight}px`;
    let accordion = this;
    setTimeout(() => {
      accordion.accordionTrigger.style.transition = 'height 0.3s ease, opacity 0.3s ease';
      accordion.accordionTrigger.style.opacity = 1;
    },200);
    this.setFullHeight();
    this.accordionTrigger.addEventListener('click', this.updateHeight.bind(this));
    window.addEventListener('resize', this.heightsUpdate.bind(this));

    if (this.classList.contains('initially-opened')) {
      this.openAccordion();
    }
  }

  heightsUpdate() {
    this.setFullHeight();
    this.initialHeight = this.querySelector('.sub-accordion-title').offsetHeight + 20;
    if (this.accordionTrigger.classList.contains('open')) {
      this.accordionTrigger.style.height = `${this.fullHeight}px`;
    }
    else {
      this.accordionTrigger.style.height = `${this.initialHeight}px`;
    }
  }

  setFullHeight() {
    const headerHeight = this.querySelector('.sub-accordion-title').offsetHeight;
    const contentHeight = this.querySelector('.sub-accordion-content').offsetHeight;
    this.fullHeight = headerHeight + contentHeight;
  }

  updateHeight(e) {
    if(!this.inProgress) {
      this.inProgress = true;
      if(this.accordionTrigger.classList.contains('open')) {
        this.closeAccordion(true);
      }
      else {
        this.closeOtherAccordions();
        this.openAccordion();
      }
      let tempAccordion = this;
      setTimeout(() => {
        tempAccordion.inProgress = false;
      },400);
    }
  }

  openAccordion() {
    let content = this.querySelector('.sub-accordion-content');
    this.accordionTrigger.style.height = `${this.fullHeight}px`;
    this.accordionTrigger.classList.add('open');
    content.style.opacity = 1;
    this.parentAccordion.updateHeight(null, content.offsetHeight);
    this.closeOtherAccordions();
  }

  closeAccordion(updateHeight) {
    let content = this.querySelector('.sub-accordion-content');
    this.accordionTrigger.style.height = `${this.initialHeight}px`;
    setTimeout(() => {
      content.style.opacity = 0;
    }, 200);
    this.accordionTrigger.classList.remove('open');
    if(updateHeight) {
      this.parentAccordion.updateHeight();
    }
  }

  closeOtherAccordions() {
    this.parentElement.querySelectorAll('faq-sub-accordion').forEach(accordion => {
      if(accordion !== this) {
        accordion.closeAccordion();
      }
    });
  }
}

if (!window.customElements.get("faq-sub-accordion")) {
  window.customElements.define("faq-sub-accordion", FaqSubAccordion);
}